import {
  CONVERSATION_FACTS_MEASURES,
  CONVERSATION_FACTS_ZONE_DIMENSIONS,
  DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS,
  DRIFT_CHAT_PLAYBOOK_DIMENSIONS,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const RoutingSankeyDrilldownBase: CubeQuery = {
  name: 'RoutingSankeyDrilldownBase',
  query: {
    dimensions: [
      CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_TEAMMATE_ROUTED_IN,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_TEAMMATE_RESPONDED,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_ROUTED_AND_SOMEONE_RESPONDED_WITHIN_60S,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.ROUTING_OUTCOME,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.TIME_TO_FIRST_RESPONSE_FORMATTED,
      CONVERSATION_FACTS_MEASURES.CONVERSATION_ID,
      DRIFT_CHAT_PLAYBOOK_DIMENSIONS.PLAYBOOK_NAME,
    ],
    order: [
      [CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT, 'desc'],
    ],
  },
  queryName: 'RoutingSankeyDrilldownBase',
}
